import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      className="design-iconfont"
    >
      <g fillRule="evenodd">
        <path
          d="M6.58624007,15.0103241 C5.80972605,15.3547544 4.90836506,15.043076 4.50338714,14.3147506 L4.42129151,14.1448478 L4.42129151,14.1448478 L4.40630768,14.1073665 C4.04049505,13.1583476 3.31604177,12.3950139 2.39437292,11.9787905 L2.19391267,11.8949715 C1.35466019,11.5714699 0.936561508,10.6288714 1.26006313,9.78961893 L1.29095511,9.7150391 C1.73280059,8.71890378 1.73280059,7.58237539 1.29095511,6.58624007 C0.946524788,5.80972605 1.2582032,4.90836506 1.98652852,4.50338714 L2.15643132,4.42129151 L2.15643132,4.42129151 L2.19391267,4.40630768 C3.14293158,4.04049505 3.90626528,3.31604177 4.32248869,2.39437292 L4.40630768,2.19391267 C4.7298093,1.35466019 5.67240775,0.936561508 6.51166023,1.26006313 L6.58624007,1.29095511 C7.58237539,1.73280059 8.71890378,1.73280059 9.7150391,1.29095511 C10.4915531,0.946524788 11.3929141,1.2582032 11.797892,1.98652852 L11.8799877,2.15643132 L11.8799877,2.15643132 L11.8949715,2.19391267 C12.2607841,3.14293158 12.9852374,3.90626528 13.9069062,4.32248869 L14.1073665,4.40630768 C14.946619,4.7298093 15.3647177,5.67240775 15.041216,6.51166023 L15.0103241,6.58624007 C14.5684786,7.58237539 14.5684786,8.71890378 15.0103241,9.7150391 C15.3547544,10.4915531 15.043076,11.3929141 14.3147506,11.797892 L14.1448478,11.8799877 L14.1448478,11.8799877 L14.1073665,11.8949715 C13.1583476,12.2607841 12.3950139,12.9852374 11.9787905,13.9069062 L11.8949715,14.1073665 C11.5714699,14.946619 10.6288714,15.3647177 9.78961893,15.041216 L9.7150391,15.0103241 C8.71890378,14.5684786 7.58237539,14.5684786 6.58624007,15.0103241 Z"
          fill="#FB9E6C"
        />
        <path
          d="M5.69511645 0L6.50180031 0.827012667 2.28159855 4.7724964 0 2.56601041 0.797905517 1.73068141 2.2728202 3.16698298z"
          transform="translate(4.723322 5.470361)"
          fill="#FFF"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  )
}

const AuthPrivateIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default AuthPrivateIcon
